import { useState, useEffect } from 'react';
import { getData } from '../../../webService/webservice.js';
const BookingHeader = ({ onApplyFilters }) => {
    const [customers, setCustomers] = useState([]);
    const [stores, setStores] = useState([]);
    const [filters, setFilters] = useState({
        status: "",
        customerId: "",
        storeId: "",
        sortBy: "",
        startDate: "",
        endDate: "",
    });
    const handleChange = (e) => {
        const { id, value } = e.target;
        setFilters((prev) => ({ ...prev, [id]: value }));
    };

    const handleClear = () => {
        const empty = {
            status: "",
            customerId: "",
            storeId: "",
            storeName: "",
            sortBy: "",
            startDate: "",
            endDate: "",
        };
        setFilters(empty);

        // Remove any persisted filters
        sessionStorage.removeItem("bookingFilters");

        if (typeof onApplyFilters === "function") {
            onApplyFilters({});
        }
    };
    const handleApply = () => {
        sessionStorage.setItem("bookingFilters", JSON.stringify(filters));
        if (typeof onApplyFilters === "function") {
            onApplyFilters(filters);
        }
    };

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                console.log('API Full Response:', data);
                const results = data?.data?.[0]?.paginatedResults || [];
                setStores(results);

            } catch (error) {
                console.error("Failed to load sub categories", error);
            }
        };
        fetchStores();
    }, []);
    useEffect(() => {
        const storedStoreId = sessionStorage.getItem("storeId");
        if (storedStoreId && stores.length > 0) {
            const matchedStore = stores.find((store) => store._id === storedStoreId);
            if (matchedStore) {
                setFilters((prev) => ({
                    ...prev,
                    storeId: matchedStore._id,
                    storeName: matchedStore.storeName,
                }));
            }
        }
    }, [stores]);

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const data = await getData('customers/customers', {}, token);  // Adjust endpoint as needed
                console.log("API Full Response: ", data);
                const results = data?.data?.[0]?.paginatedResults || [];
                setCustomers(results);
            } catch (error) {
                console.error("Failed to load customers", error);
            }
        };

        fetchCustomers();
    }, []);
    return (
        <>
            <div className="Booking-widgets">
                <div className="Filters">
                    <h4>Filters</h4>
                </div>

                {/* Status */}
                <div className="booking-status-filter">
                    <select
                        id="status"
                        className="booking-status-input"
                        value={filters.status || ""}
                        onChange={handleChange}
                    >
                        <option value="">Status</option>
                        <option value="Completed">Completed</option>
                        <option value="In Progress">In Progress</option>
                        <option value="Pending">Pending</option>
                        <option value="Cancelled">Cancelled</option>
                        <option value="Scheduled">Scheduled</option>
                        <option value="Rejected">Rejected</option>
                        <option value="Approved">Approved</option>
                    </select>
                </div>

                {/* Customer */}
                <div className="Customer-filter-button">
                    <select
                        id="customerId"
                        className="booking-status-input"
                        value={filters.customerId || ""}
                        onChange={handleChange}
                    >
                        <option value="">All Customers</option>
                        {customers?.map((cust) => (
                            <option key={cust._id} value={cust._id}>
                                {cust.name}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Location */}
                <div className="Location-filter-button">
                    <select
                        id="storeId"
                        className="booking-status-input"
                        value={filters.storeId || ""}
                        onChange={(e) =>
                            setFilters((prev) => ({
                                ...prev,
                                storeId: e.target.value,
                            }))
                        }
                    >
                        <option value="">All Locations</option>
                        {stores?.map((store) => (
                            <option key={store._id} value={store._id}>
                                {store.storeName}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Sort */}
                <div className="Sort-filter-button">
                    <select
                        id="sortBy"
                        className="booking-status-input"
                        value={filters.sortBy}
                        onChange={handleChange}
                    >
                        <option value="">Sort By</option>
                        <option value="dateAsc">Date (Oldest First)</option>
                        <option value="dateDesc">Date (Newest First)</option>
                        <option value="status">Status</option>
                    </select>
                </div>
            </div>

            {/* Date Filter */}
            <div className="Date">
                <div className="Date-Filter">
                    <h4>Date Filter</h4>
                </div>
                <div className="Start-Date-Range">
                    <label>Start Date</label>
                    <input
                        type="date"
                        id="startDate"
                        className="booking-status-input"
                        value={filters.startDate || ""}
                        onChange={handleChange}
                    />
                </div>
                <div className="End-Date-Range">
                    <label>End Date</label>
                    <input
                        type="date"
                        id="endDate"
                        className="booking-status-input"
                        value={filters.endDate || ""}
                        onChange={handleChange}
                    />
                </div>

                <div className="Buttons">
                    <div className="clear-button">
                        <button className="clear" onClick={handleClear}
                        type='button'
                        style={
                            {
                                cursor:"pointer"
                            }
                        }
                        >
                            Clear
                        </button>
                    </div>
                    <div className="apply-button">
                        <button
                            className="Apply"
                            type='button'
                            style={{
                                border: "0px",
                                borderRadius: "10px",
                                padding: "10px",
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "white",
                                background: "linear-gradient(#A16A70, #D98484)",
                                cursor:"pointer"
                            }}
                            onClick={handleApply}
                        >
                            Apply
                        </button>
                    </div>
                </div>
            </div>
        </>

    );
};

export default BookingHeader;